// thunk actions

import { getAccountSessionToken, logout } from "./login";
import axios from "axios";
import { HttpCodes } from "./constants";
import history from "./history";
import moment from "moment";
import { ToastType } from "../components/ToastManager/constants";
import { sendNotification } from "../components/ToastManager/ToastManager";
import { apiBase } from "../config";
import i18n from "../i18n";

export let source = axios.CancelToken.source();

export const refreshSource = () => {
  source = axios.CancelToken.source();
};

//  Storage pengding Request container
const pendingList = new Map();
//  Generate each request ID
export const getFetchKey = (config) => {
  if (!config) {
    return null;
  }

  const { url, data, method } = config;
  let token;
  if (method === "get") {
    token = [method, url].join("&");
  } else {
    token = [method, url, JSON.stringify(data)].join("&");
  }
  return token;
};
//  add to pengding request
export const addPending = (config) => {
  const fetchKey = getFetchKey(config);
  if (fetchKey) {
    if (!pendingList.has(fetchKey)) {
      pendingList.set(fetchKey, config);
    }
  }
};
//  remove pengding request
export const removePending = (config) => {
  const fetchKey = getFetchKey(config);
  if (fetchKey) {
    if (pendingList.has(fetchKey)) {
      pendingList.delete(fetchKey);
    }
  }
};
//  Cancel the request
export const cancelPending = (config) => {
  const fetchKey = getFetchKey(config);
  if (fetchKey) {
    if (pendingList.has(fetchKey)) {
      const localSrc = axios.CancelToken.source();

      const req = pendingList.get(fetchKey);
      req.cancelToken = localSrc.token;

      localSrc.cancel("cancel"); // not remove this "cancel" string to avoid showing up a error message
      pendingList.delete(fetchKey);
    }
  }
};

export const setupInterceptors = (store) => {
  const allowedUrls = [
    `/api/account/login`,
    `/api/account/registration`,
    `/api/account/confirmation`,
    `/api/account/validatetoken`,
    `/api/account/management/admin/registration`,
    `/api/account/recoverpassword`,
    `/api/account/recoverchangepassword`,
    `/api/participant/birthdate`,
    `/api/survey/definition`,
    `/api/survey/eligibility`,
  ];

  const urlsToPreventDuplicateRequests = [
    `/api/nonparticipants`,
    `/api/participant/getBySite`,
    `/api/account/management`,
    `/api/account/management/participants`,
    `/api/diet/changerequest/list`,
    `/api/audittrail/comments`,
  ];

  axios.interceptors.request.use((req) => {
    req.cancelToken = source.token;

    //Cancel request without token
    if (
      !getAccountSessionToken(store.getState()) &&
      !allowedUrls.find((url) => req.url.includes(url))
    ) {
      source.cancel("cancel");
      refreshSource();
      return req;
    }

    if (
      getAccountSessionToken(store.getState()) ||
      allowedUrls.find((url) => req.url.includes(url))
    ) {
      req.baseURL = apiBase();
      req.headers = {
        ...buildAuthorizationHeaders(getAccountSessionToken(store.getState())),
        timeZoneOffset: moment.parseZone(new Date()).utcOffset(),
      };

      if (
        urlsToPreventDuplicateRequests.find((url) => req.url?.includes(url))
      ) {
        //  Before sending a request, first check whether the request has been repeated , If it is repeated, cancel and remove
        cancelPending(req);
        //  Add the request to pendingList in
        addPending(req);
      }

      return req;
    } else {
      return Promise.reject("err");
    }
  });

  axios.interceptors.response.use(
    (ok) => ok,
    (err) => {
      removePending(err.response);

      let reqUrl = err.response?.config?.url ?? "";
      reqUrl = reqUrl.toLowerCase();
      if (!reqUrl.includes("/api/account/login")) {
        switch (err?.response?.status) {
          case HttpCodes.UNAUTHORIZED: {
            const message = i18n.t("appText.doubleSession.message");

            history.push("/home");
            store.dispatch(logout());
            sendNotification(message, ToastType.ERROR);
            return Promise.reject(err);
          }
          default:
            return Promise.reject(err);
        }
      }
      return Promise.reject(err);
    }
  );

  axios.interceptors.response.use((response) => {
    //  Request successfully removed pending state
    removePending(response);
    return Promise.resolve(response);
  });
};

const buildAuthorizationHeaders = (token) => {
  return {
    Authorization: "Bearer " + token,
  };
};

export const parseParams = (params) => {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && params[key].length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
};
